import moment from 'moment';
import {
  DELETE_USER_SETTINGS_SUCCESS,
  LOAD_USER_SETTINGS_FAILURE,
  LOAD_USER_SETTINGS_PENDING,
  LOAD_USER_SETTINGS_SUCCESS,
  PUT_USER_SETTINGS_SUCCESS,
} from '../actions/actionTypes';
import { Action, ActionMeta } from '../actions/commonActions';
import { SimManagementError } from '../models/Errors';
import { initialAppState } from '../models/state/appState';
import { UserSettings, UserSettingsState, getDefaultUserSettingsState } from '../models/state/userSettings';

/**
 * The number of seconds the application will wait before refreshing user settings from the server.
 */
export const UserSettingsCacheTimeout = 3600;

/**
 * Reducer which deals with processing user settings
 * @param state Initial state.
 * @param action An action.
 */
export default function userSettingsReducer(
  state: UserSettingsState = initialAppState.userSettings,
  action: Action<any> | ActionMeta<any, any>
): UserSettingsState {
  switch (action.type) {
    case LOAD_USER_SETTINGS_PENDING: {
      const typedAction = action as Action<string>;
      const id = typedAction.payload;
      if (!id) {
        return state;
      }

      const newState = getDefaultUserSettingsState();
      newState.userId = id;
      newState.isLoading = true;

      return newState;
    }
    case LOAD_USER_SETTINGS_FAILURE: {
      const typedAction = action as ActionMeta<SimManagementError, string>;
      if (!typedAction.payload || !typedAction.meta) {
        return state;
      }

      const newState = getDefaultUserSettingsState();
      newState.userId = typedAction.meta;
      newState.error = typedAction.payload;

      return newState;
    }
    case LOAD_USER_SETTINGS_SUCCESS:
    case PUT_USER_SETTINGS_SUCCESS: {
      const typedAction = action as Action<UserSettings>;
      if (!typedAction.payload) {
        return state;
      }

      const newState: UserSettingsState = {
        ...typedAction.payload,
        isLoading: false,
        lastLoadedOn: new Date(),
        expiresOn: moment().add(UserSettingsCacheTimeout, 'seconds').toDate(),
      };

      return newState;
    }
    case DELETE_USER_SETTINGS_SUCCESS: {
      const typedAction = action as Action<UserSettings>;
      if (!typedAction.payload) {
        return state;
      }

      const newState = getDefaultUserSettingsState();
      newState.userId = typedAction.payload.userId;
      newState.lastLoadedOn = new Date();
      newState.expiresOn = moment().add(UserSettingsCacheTimeout, 'seconds').toDate();

      return newState;
    }
    default:
      return state;
  }
}
